document.addEventListener("DOMContentLoaded", function () {
  function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const countEl = document.querySelector('[data-cart-count]');
      const bubble = document.querySelector('.cart-count-bubble');

      if (countEl) countEl.textContent = count;

      if (bubble) {
        if (count > 0) {
          bubble.classList.remove('hidden');

          // Trigger bounce animation
          bubble.classList.remove('animate'); // reset if already added
          void bubble.offsetWidth; // force reflow
          bubble.classList.add('animate');
        } else {
          bubble.classList.add('hidden');
        }
      }

      // Update cart icon (optional, from previous step)
      const iconWrapper = document.querySelector('#cart-icon-bubble .svg-wrapper');
      const filledIcon = document.querySelector('#cart-icon-filled');
      const emptyIcon = document.querySelector('#cart-icon-empty');

      if (iconWrapper && filledIcon && emptyIcon) {
        const iconHtml = (count > 0 ? filledIcon.innerHTML : emptyIcon.innerHTML).trim();
        if (iconWrapper.innerHTML.trim() !== iconHtml) {
          iconWrapper.innerHTML = iconHtml;
        }
      }
    });
}


  function handleAddToCart(form) {
  const button = form.querySelector('[type="submit"]');
  if (!button) return;

  const buttonText = button.querySelector('span:not(.sold-out-message)');
  const spinner = button.querySelector('.loading__spinner');

  const originalText = buttonText ? buttonText.textContent : 'Add to cart';

  // Show spinner, hide text
  if (spinner) spinner.classList.remove('hidden');
  if (buttonText) buttonText.classList.add('hidden');

  button.disabled = true;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(data => {
      updateCartCount();

      // Hide spinner, show "Added"
      if (spinner) spinner.classList.add('hidden');
      if (buttonText) {
        buttonText.textContent = 'Added';
        buttonText.classList.remove('hidden');
      }

      setTimeout(() => {
        if (buttonText) buttonText.textContent = originalText;
        button.disabled = false;
      }, 1500);
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      if (spinner) spinner.classList.add('hidden');
      if (buttonText) {
        buttonText.textContent = originalText;
        buttonText.classList.remove('hidden');
      }
      button.disabled = false;
    });
}



  function bindAjaxAddToCartHandlers(context = document) {
    context.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
      // Avoid binding multiple times
      if (form.classList.contains('ajaxified')) return;
      form.classList.add('ajaxified');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleAddToCart(form);
      }, true);
    });
  }

  // Initial bind
  bindAjaxAddToCartHandlers();

  // Bind again if grid is re-rendered dynamically
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          bindAjaxAddToCartHandlers(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
